<script>
export default {
  name: 'HamburguerButton',
  props: {
    onclick: String,
    isSidebarHidden: Boolean,
    isSidebarCollapsed: Boolean,
  },
  emits: ['onclick']
}
</script>

<template>
  <button class="tw-h-full tw-min-w-[53px] tw-btn-primary tw-rounded-none tw-bg-transparent dark:hover:tw-bg-[#102230] hover:tw-bg-[#F5F5F6] tw-p-0 tw-mb-0 tw-mr-1 focus-visible:tw-outline focus-visible:tw-outline-[#111827] dark:focus:tw-outline-[#9EC0DC] focus-visible:tw-outline-2"  v-on:click="$emit('onclick')">
    <span class="tw-sr-only">Open main menu</span>
    <div class="tw-block tw-w-5 tw-absolute tw-text-[#111827] dark:tw-text-white tw-left-1/2 tw-top-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2">
        <span aria-hidden="true" 
              class="tw-block tw-absolute tw-h-0.5 tw-w-5 tw-bg-current tw-transform tw-transition tw-duration-300 ease-in-out" 
              :class="[ !isSidebarHidden && !isSidebarCollapsed ? 'tw-rotate-45 lg:tw-rotate-0 lg:tw--translate-y-1.5' : 'tw--translate-y-1.5' ]">
        </span>
        <span aria-hidden="true" 
              class="tw-block tw-absolute tw-h-0.5 tw-w-5 tw-bg-current tw-transform tw-transition tw-duration-300 ease-in-out" 
              :class="[ !isSidebarHidden && !isSidebarCollapsed ? 'tw-opacity-0 lg:tw-opacity-100' : '' ]">
        </span>
        <span aria-hidden="true" 
              class="tw-block tw-absolute tw-h-0.5 tw-w-5 tw-bg-current tw-transform tw-transition tw-duration-300 ease-in-out" 
              :class="[ !isSidebarHidden && !isSidebarCollapsed ? 'tw--rotate-45 lg:tw-rotate-0 lg:tw-translate-y-1.5' : 'tw-translate-y-1.5' ]">
        </span>
    </div>
  </button>
</template>
